/*
 * darshan.js — interactions de la page Darshan Paris 2027.
 * Trois choses seulement : l'accordéon des questions, les compteurs qui s'animent
 * à l'arrivée dans l'écran, et les flèches du bandeau de photos.
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------- questions
  document.querySelectorAll('.faq__item').forEach(function (item) {
    var bouton = item.querySelector('.faq__q');
    var reponse = item.querySelector('.faq__r');
    bouton.setAttribute('aria-expanded', 'false');

    bouton.addEventListener('click', function () {
      var ouvert = item.dataset.ouvert === 'true';
      // Une seule réponse ouverte à la fois : la page reste lisible.
      document.querySelectorAll('.faq__item[data-ouvert="true"]').forEach(function (autre) {
        autre.dataset.ouvert = 'false';
        autre.querySelector('.faq__r').style.maxHeight = '0px';
        autre.querySelector('.faq__q').setAttribute('aria-expanded', 'false');
      });
      if (!ouvert) {
        item.dataset.ouvert = 'true';
        reponse.style.maxHeight = reponse.scrollHeight + 'px';
        bouton.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ---------------------------------------------------------------- compteurs
  var compteurs = document.querySelectorAll('[data-compte]');
  var doux = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function anime(el) {
    var cible = parseInt(el.dataset.compte, 10);
    var suffixe = el.dataset.suffixe || '';
    if (doux) { el.textContent = cible + suffixe; return; }

    var debut = null;
    var duree = 1100;
    function pas(t) {
      if (debut === null) debut = t;
      var p = Math.min(1, (t - debut) / duree);
      // Décélération : le chiffre se pose au lieu de s'arrêter net.
      var v = Math.round(cible * (1 - Math.pow(1 - p, 3)));
      el.textContent = v + suffixe;
      if (p < 1) requestAnimationFrame(pas);
    }
    requestAnimationFrame(pas);
  }

  if ('IntersectionObserver' in window) {
    var oeil = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        anime(e.target);
        oeil.unobserve(e.target);
      });
    }, { threshold: .4 });
    compteurs.forEach(function (c) { oeil.observe(c); });
  } else {
    compteurs.forEach(anime);
  }

  // --------------------------------------------- sélecteur satsang / darshan
  // Cocher les deux fait basculer sur le forfait soirée entière, moins cher
  // que la somme des deux billets.
  var FORFAIT = 65;

  var choix = document.getElementById('choix');
  if (choix) {
    var cases = [].slice.call(choix.querySelectorAll('.opt__case'));
    var recap = choix.querySelector('.total');
    var nom = document.getElementById('total-nom');
    var somme = document.getElementById('total-somme');
    var eco = document.getElementById('total-eco');
    var detail = document.getElementById('total-detail');
    var bouton = document.getElementById('total-bouton');

    var libelles = { satsang: 'Satsang', darshan: 'Darshan' };

    function recalcule() {
      var prises = cases.filter(function (c) { return c.checked; });
      var brut = prises.reduce(function (t, c) { return t + parseInt(c.dataset.prix, 10); }, 0);
      var forfait = prises.length === 2;
      var total = forfait ? FORFAIT : brut;

      detail.innerHTML = '';
      prises.forEach(function (c) {
        var li = document.createElement('li');
        li.innerHTML = '<span>' + libelles[c.dataset.cle] + '</span><span>'
          + c.dataset.prix + ' €</span>';
        detail.appendChild(li);
      });

      if (!prises.length) {
        nom.textContent = 'Rien de sélectionné';
        somme.textContent = '—';
        eco.textContent = 'Cochez au moins une formule';
        bouton.textContent = 'Choisissez une formule';
        recap.dataset.vide = 'true';
        return;
      }

      recap.dataset.vide = 'false';
      nom.textContent = forfait ? 'Les deux soirées' : libelles[prises[0].dataset.cle] + ' seul';
      somme.textContent = total + ' €';
      eco.textContent = forfait ? 'Vous économisez ' + (brut - FORFAIT) + ' €' : '';
      bouton.textContent = "Être prévenu de l'ouverture";

      if (forfait) {
        var li = document.createElement('li');
        li.innerHTML = '<span>Forfait deux soirées</span><span>− ' + (brut - FORFAIT) + ' €</span>';
        detail.appendChild(li);
      }
    }

    cases.forEach(function (c) {
      c.addEventListener('change', function () {
        recalcule();
        // Le formulaire du bas reflète les formules choisies ici : on évite à la
        // personne de recocher deux fois la même chose.
        var jumelle = document.querySelector('.formu [name="interets"][value="' + c.dataset.cle + '"]');
        if (jumelle) jumelle.checked = c.checked;
      });
    });
    recalcule();
  }

  // Les liens « m'intéresser à … » précochent la formule correspondante.
  document.querySelectorAll('a[data-interet]').forEach(function (lien) {
    lien.addEventListener('click', function () {
      var cible = document.querySelector('.formu [name="interets"][value="' + lien.dataset.interet + '"]');
      if (cible) cible.checked = true;
    });
  });

  // ------------------------------------------------------------- formulaire
  // Les demandes partent vers l'extranet de l'équipe France (darshan-api.php),
  // qui les affiche dans sa boîte de réception. Rien n'est stocké côté Shopify.
  var POINT_ENTREE = 'https://callerfrancevitthal.bmcountry.org/darshan-api.php';

  var formu = document.getElementById('formu');
  if (formu) {
    var envoi = document.getElementById('f-envoi');
    var etat = document.getElementById('f-etat');
    var ouvertureMs = Date.now();

    function dis(texte, genre) {
      etat.textContent = texte;
      etat.dataset.genre = genre || '';
    }

    formu.addEventListener('submit', function (e) {
      e.preventDefault();

      var prenom = formu.prenom.value.trim();
      var nom = formu.nom.value.trim();
      var email = formu.email.value.trim();

      if (!prenom || !nom) { return dis('Merci d’indiquer votre prénom et votre nom.', 'erreur'); }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        return dis('Cette adresse e-mail ne semble pas valide.', 'erreur');
      }
      if (!formu.consentement.checked) {
        return dis('Merci de cocher l’autorisation de vous recontacter.', 'erreur');
      }

      var corps = new URLSearchParams();
      corps.append('prenom', prenom);
      corps.append('nom', nom);
      corps.append('email', email);
      corps.append('telephone', formu.telephone.value.trim());
      corps.append('ville', formu.ville.value.trim());
      corps.append('message', formu.message.value.trim());
      corps.append('consentement', '1');
      corps.append('site', formu.site.value);
      corps.append('t0', String(ouvertureMs));
      formu.querySelectorAll('[name="interets"]:checked').forEach(function (c) {
        corps.append('interets[]', c.value);
      });

      envoi.disabled = true;
      dis('Envoi en cours…', '');

      fetch(POINT_ENTREE, { method: 'POST', body: corps })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || !res.j.ok) {
            throw new Error(res.j && res.j.erreur ? res.j.erreur : 'Envoi impossible.');
          }
          formu.innerHTML =
            '<div class="formu__merci">'
            + '<p class="formu__merci-titre">Merci ' + (res.j.prenom || '') + '.</p>'
            + '<p>Votre demande est arrivée. Nous vous écrirons dès l’ouverture des '
            + 'réservations, et plus tôt si vous nous avez posé une question.</p>'
            + '<p class="formu__merci-pied">Jai Gurudev 🙏</p>'
            + '</div>';
        })
        .catch(function (err) {
          envoi.disabled = false;
          dis(err.message + ' Vous pouvez aussi nous écrire à contact@bhaktimarga.fr.', 'erreur');
        });
    });
  }

  // ------------------------------------------------------- bandeau de photos
  // Molette verticale au-dessus du bandeau : on la traduit en défilement latéral.
  var bande = document.getElementById('bande');
  if (bande) {
    bande.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var avant = bande.scrollLeft;
      bande.scrollLeft += e.deltaY;
      // On ne confisque la molette que si le bandeau a effectivement bougé.
      if (bande.scrollLeft !== avant) e.preventDefault();
    }, { passive: false });
  }
})();
